import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import CookieImage from 'common/images/cookies.png';
import styles from './CookieBar.module.scss';
import { Container } from 'common/components/Layout/Layout';
import Cookies from 'universal-cookie';
import Bind from 'lodash-decorators/bind';
import messages from './CookieBar.intl.js';

const COOKIE_KEY = 'cookieAgrement';
@injectIntl
export default class CookieBar extends Component {
  state = {
    hasCookie: false
  };

  constructor(props) {
    super(props);
    this.cookieProvider = new Cookies();
  }

  componentDidMount() {
    this.setState({ hasCookie: this.cookieProvider.get(COOKIE_KEY) });
  }

  @Bind
  setCookie() {
    this.cookieProvider.set(COOKIE_KEY, true);
    this.setState({ hasCookie: true });
  }

  render() {
    return this.state.hasCookie ? null : (
      <div className={styles.CookieBarWrapper}>
        <Container className={styles.CookieBar}>
          <div className={styles.CookierBarImg}>
            <img src={CookieImage} alt="cookies" />
          </div>
          <p className={styles.CookieText}>
            {this.props.intl.formatMessage(messages.cookieAgreementText)}
          </p>
          <div>
            <button onClick={this.setCookie} className={styles.CookieButton}>
              {this.props.intl.formatMessage(messages.cookieButtonText)}
            </button>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/CookieBar/CookieBar.js